import { apiService } from "@/services";
import { settings } from "@/settings";
import { OrganizationsClient } from "./GeneratedClients";

const organizationRepository = new OrganizationsClient(settings.webApi.baseUrl, apiService.getApiClient());

export { organizationRepository };
